import React, { useEffect, useState } from 'react';
import { Check, Minus } from 'lucide-react';

const OptionCard = ({ option, side, testId, image }) => {
  const dark = side === 'a';
  return (
    <div
      className={`relative rounded-2xl overflow-hidden ${dark ? 'bg-[#3a190b] text-white' : 'bg-[#f4efe9] text-[#202020] border border-[#3a190b]/10'}`}
      data-testid={testId}
    >
      {image && (
        <figure className="relative aspect-[4/3]">
          <img src={`${process.env.REACT_APP_BACKEND_URL}/api/files/${image}`} alt={option.name} loading="lazy" className="w-full h-full object-cover" data-testid={`${testId}-image`} />
          <figcaption className="absolute bottom-2 right-2 text-[10px] uppercase tracking-wider bg-white/85 text-[#3a190b] px-2 py-0.5 rounded-full">Sfeerbeeld</figcaption>
        </figure>
      )}
      <div className="p-7 md:p-9">
      <p className={`text-xs uppercase tracking-[0.2em] mb-2 ${dark ? 'text-white/60' : 'text-[#3a190b]/70'}`}>Optie {side.toUpperCase()}</p>
      <h2 className="text-2xl md:text-3xl font-bold mb-1">{option.name}</h2>
      <p className={`text-sm mb-6 ${dark ? 'text-white/75' : 'text-[#202020]/70'}`}>{option.tagline}</p>
      <dl className={`grid grid-cols-2 gap-4 text-sm mb-6 pb-6 border-b ${dark ? 'border-white/15' : 'border-[#3a190b]/10'}`}>
        <div><dt className={`text-xs ${dark ? 'text-white/50' : 'text-[#202020]/50'}`}>Prijs</dt><dd className="font-semibold">{option.price}</dd></div>
        <div><dt className={`text-xs ${dark ? 'text-white/50' : 'text-[#202020]/50'}`}>Ruimte / tijd</dt><dd className="font-semibold">{option.space}</dd></div>
      </dl>
      <ul className="space-y-2 mb-5">
        {option.pros.map((p) => (
          <li key={p} className="flex gap-2 text-sm"><Check className={`h-4 w-4 mt-0.5 flex-shrink-0 ${dark ? 'text-emerald-300' : 'text-emerald-600'}`} aria-hidden="true" />{p}</li>
        ))}
      </ul>
      <ul className="space-y-2">
        {option.cons.map((c) => (
          <li key={c} className={`flex gap-2 text-sm ${dark ? 'text-white/70' : 'text-[#202020]/65'}`}><Minus className="h-4 w-4 mt-0.5 flex-shrink-0 opacity-60" aria-hidden="true" />{c}</li>
        ))}
      </ul>
      </div>
    </div>
  );
};

const VersusCards = ({ a, b, slug }) => {
  const [images, setImages] = useState({});
  useEffect(() => {
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/comparisons/images`).then((r) => r.json()).then((d) => setImages(d[slug] || {})).catch(() => {});
  }, [slug]);
  return (
  <section className="py-12 md:py-16 bg-white" data-testid="versus-cards">
    <div className="max-w-7xl mx-auto px-4 relative">
      <div className="grid md:grid-cols-2 gap-6 md:gap-10">
        <OptionCard option={a} side="a" testId="option-a-card" image={images.a} />
        <OptionCard option={b} side="b" testId="option-b-card" image={images.b} />
      </div>
      <div className="hidden md:flex absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-16 h-16 rounded-full bg-white shadow-xl border-4 border-[#f4efe9] items-center justify-center font-black text-[#3a190b] text-lg tracking-tight" aria-hidden="true">VS</div>
    </div>
  </section>
  );
};

export default VersusCards;
